var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkout-duties-confirmation"},[_c('input',{staticClass:"checkout-duties-confirmation__check",attrs:{"type":"checkbox","required":""}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }